<template>
  <el-dialog :title="title" :visible.sync="dialogTableVisible" @close="closeDialog" width="60%">
    <el-table :data="unbind_list" border v-loading="loading">
      <el-table-column property="id" label="线索ID"></el-table-column>
      <el-table-column property="contact_name" label="申请人"></el-table-column>
      <template v-if="type == 1">
        <el-table-column property="bind_at" label="绑定时间"></el-table-column>
        <el-table-column property="trace_at" label="跟进时间"></el-table-column>
      </template>
      <template v-else-if="type == 2">
        <el-table-column property="unbind_and_transfer_at" label="解绑/转交时间"></el-table-column>
      </template>
      <el-table-column property="sl_user_name" label="业务员"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
  </el-dialog>
</template>
<style scoped>
</style>
<script>
import ClueCount from "~/services/ClueCount";
import MyPagination from "~/widgets/MyPagination.vue";

export default {
  name: "ValidityDialog",

  components: {
    MyPagination,
  },

  props: {
    params:{
      type: Object,
      required: true,
    },
    title:{
      type: String,
      required: false,
      default: '接收线索'
    },
    type:{
      type: Number,
      required: false,
      default: 1
    }
  },

  data() {
    return {
      loading: false,
      // 分页信息
      linkPage: null,
      unbind_list: [],
      dialogTableVisible: false,
      active_name: 'validity-list',
      searcheModel: {},
    };
  },

  mounted() {
    
  },

  created: function () {
    this.dialogTableVisible = true;
    this.searcheModel = _.clone(this.params);
    this.getList(this.searcheModel);
  },

  methods: {
    //获取列表
    getList(params) {
      // loading 动画
      this.loading = true;
      ClueCount.getList(params, this.active_name)
        .then((res) => {
            if (res.code == 0) {
                this.unbind_list = res.data;
            }
            if (res._meta) {
                this.linkPage = res._meta;
            }
            this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },


    handleSizeChange(newSize) {
        // 处理每页条目数变化事件
        let params = this.searcheModel;
        params['perPage'] = newSize;
        this.getList(params);
    },

    handleCurrentChange(newPage) {
        let params = this.searcheModel;
        // 处理当前页码变化事件
        params['page'] = newPage;
        this.getList(params);
    },

    // 查看、编辑、删除、绑定、转交销售线索操作
    handleView(clue) {
        let routeData = this.$router.resolve({
            path: "/sales-leads/view",
            query: { id: clue.id, referer: this.$route.path },
        });
        window.open(routeData.href, '_blank');
    },

    closeDialog(){
      this.dialogTableVisible = false;
      this.$emit("close", []);
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/views/count/dialog/ValidityDialog.vue